import { motion } from "framer-motion";

/** Static animated mesh-gradient blobs for use on dark hero sections. */
export default function MeshGradient({ className = "" }) {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`} aria-hidden="true">
      <motion.div
        className="mesh-blob"
        style={{ background: "radial-gradient(circle, hsl(152 76% 50% / 0.45), transparent 70%)", width: "42rem", height: "42rem", top: "-8rem", left: "-6rem" }}
        animate={{ x: [0, 60, -20, 0], y: [0, -30, 40, 0] }}
        transition={{ duration: 24, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="mesh-blob"
        style={{ background: "radial-gradient(circle, hsl(152 90% 60% / 0.25), transparent 70%)", width: "36rem", height: "36rem", top: "20%", right: "-8rem" }}
        animate={{ x: [0, -40, 30, 0], y: [0, 40, -20, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut", delay: -8 }}
      />
      <motion.div
        className="mesh-blob"
        style={{ background: "radial-gradient(circle, hsl(159 76% 12% / 0.6), transparent 70%)", width: "50rem", height: "50rem", bottom: "-10rem", left: "30%" }}
        animate={{ x: [0, 30, -20, 0], y: [0, -20, 30, 0] }}
        transition={{ duration: 32, repeat: Infinity, ease: "easeInOut", delay: -16 }}
      />
    </div>
  );
}
